import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { LoadingService } from './loading.service';
import { ToasterService } from './toaster.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private api: ApiService,
              private loadingService: LoadingService,
              private toasterService: ToasterService) {
  }

  downloadFilesAsZip(fileIds: string[],fileName?: string) {
    this.loadingService.show();
    this.api.downloadFilesAsZip(fileIds).subscribe({
      next: (response) => {
        const blob = new Blob([response], { type: 'application/zip' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName ? `${fileName}.zip` : 'attachments.zip'; // File name for the download
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        this.loadingService.hide();
      },
      error: (error) => {
        this.toasterService.error(error.error.errorDesc);
        this.loadingService.hide();
      }
    });
  }
}
